<template>
  <div class="order-header">
    <div class="order-item-header">
      <div class="header-left">
        <div class="status-box">
          <div class="order-status">
            {{ orderStatus[orderItem.order_status] }}
          </div>
        </div>
        <div class="tag-list">
          <div class="tag red" v-if="orderItem.need_urgent">
            <span>加急</span>
          </div>
          <div class="tag green" v-if="orderItem.first_order">
            <span>首单</span>
          </div>
          <div
            class="tag deep-green"
            v-if="!orderItem.first_order && orderItem.order_number"
          >
            <span>No.{{ orderItem.order_number }}</span>
          </div>
        </div>
      </div>
      <div class="order-title">{{ orderItem.product_name }}</div>
    </div>

    <div class="order-item-info">
      <div
        class="order-item-info-li hover-style"
        @click.stop="showOrderDetail(orderItem.id)"
      >
        订单号：<span class="order-id-href">{{ orderItem.id }}</span>
      </div>
      <div class="order-item-info-li">
        出行日期：{{ orderItem.depart_date }}
      </div>
    </div>
  </div>
</template>

<script>
import { env } from '@/services/dev';
import utils from '@/services/tools';

export default {
  props: {
    orderItem: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      orderStatus: {
        0: '已取消',
        1: '待上传资料',
        2: '待填写申请表',
        3: '待支付',
        4: '待邮寄资料',
        5: '办理中',
        6: '已发货',
        7: '待评价',
        8: '已完成',
        9: '已删除',
        10: '待选择日期',
      },
      isPC:
        (navigator.userAgent.indexOf('Windows') > -1 ||
          navigator.userAgent.indexOf('Mac') > -1) &&
        navigator.userAgent.indexOf('iPhone') === -1,
    };
  },
  methods: {
    // 打开订单详情
    showOrderDetail(orderId) {
      const url = `https://${env.env}oss.11visa.com/#/order/detail/${orderId}`;
      if (this.isPC) {
        ww.openDefaultBrowser({
          url,
        });
      } else {
        window.location.href = url;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.order-item-header {
  display: flex;
  align-items: flex-start;
  min-height: 36px;
  padding: 6px 16px 0 0;
  .header-left {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    .status-box {
      position: relative;
    }
    .order-status {
      height: 20px;
      font-size: 12px;
      padding: 0 12px;
      color: white;
      display: flex;
      align-items: center;
      justify-content: center;
      background-image: url('../../../../../../../../assets/imgs/work-wx/customer/order-status.png');
      background-position: right center;
      background-repeat: no-repeat;
      background-size: auto 100%;
      float: left;
    }
    .tag-list {
      display: flex;
      margin-top: 10px;
      margin-left: 12px;
      .tag {
        margin-right: 10px;
        padding: 0 6px;
        height: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 2px;
        &:last-child {
          margin-right: 0;
        }
        &.red {
          background: fade(#f25060, 10);
          span {
            color: #f25060;
            font-size: 12px;
          }
        }
        &.green {
          background: fade(#07c160, 60);
          span {
            color: #fff;
            font-size: 12px;
          }
        }
        &.deep-green {
          background: fade(#17ddbb, 10);
          span {
            color: #17ddbb;
            font-size: 12px;
          }
        }
      }
    }
  }

  .order-title {
    margin-left: 10px;
    flex: 1;
    font-size: 14px;
    line-height: 20px;
    color: #222222;
    font-weight: 600;
  }

  .fill-space {
    flex: 1;
  }
  .order-num {
    color: #717785;
    font-size: 14px;
    line-height: 20px;
  }
  .copy-order-num {
    margin-left: 4px;
    color: #3fa2f5;
    font-size: 14px;
    line-height: 20px;
    cursor: pointer;
  }
}

.order-item-info {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  flex-wrap: wrap;
  padding: 0 15px 0;
  line-height: 24px;
  .order-item-info-li {
    font-size: 12px;
    margin-right: 16px;
    .order-id-href {
      color: #3fa2f5;
      cursor: pointer;
    }
  }
  .hover-style {
    cursor: pointer;
  }
}
</style>
